export default function employeesService($http, RESOURCES, API_V2_HEADER) {
  var employeesSegment = '/employees';

  return {
    getEmployees: getEmployees,
    getEmployee: getEmployee,
    createEmployee: createEmployee,
    updateEmployee: updateEmployee,
    deleteEmployee: deleteEmployee,
  };

  function getEmployee(merchantId, employeeId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + employeesSegment + '/' + employeeId);
  }

  function getEmployees(merchantId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + employeesSegment);
  }

  function createEmployee(merchantId, data) {
    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + employeesSegment, data, {
      headers: API_V2_HEADER.headers,
    });
  }

  function updateEmployee(merchantId, employeeId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + employeesSegment + '/' + employeeId, data);
  }

  function deleteEmployee(merchantId, employeeId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + employeesSegment + '/' + employeeId);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/employees/employees.service.js